<template>
  <b-container class="background">
    <router-view/>
  </b-container>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js'
    }
  },
  methods: {
    ...mapActions([
      'getAccountAPI',
      'getInitData'
    ])
  },
  created () {
    this.getInitData().then((result) => {
      let param = {'appID': result.appId,
        'channelID': result.channelId,
        'customToken': result.customToken,
        'domain': result.domain
      }
      this.$i18n.set(result.lang.toLowerCase())
      this.getAccountAPI(param).then((result2) => {
        if (result2.status === 200) {
          let result = result2.data.data
          if (result.enable === '1') {
            this.$router.push({
              name: 'edit'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
        } else {
          this.$router.push({
            name: 'login'
          })
        }
      })
    })
  }
}
</script>

<style>
@font-face {
  font-family: kanit;
}
</style>
